import { useState } from 'react';

const emailHooks = () => {
  const [idQuotation, setidQuotation] = useState(null);
  const [modalEmails, setModalEmails] = useState({
    isVisible: false,
    handleCancel: () => { },
    handleOk: () => { },
  });
  const handleShowModalSendEmail = (quotationId) => {
    setModalEmails({ isVisible: true, handleCancel: () => setModalEmails({ isVisible: false }) });
    setidQuotation(quotationId);
  };

  return [modalEmails, handleShowModalSendEmail, idQuotation];
};

export default emailHooks;
